import { render, staticRenderFns } from "./AssignmentDetail.vue?vue&type=template&id=039f7945&"
import script from "./AssignmentDetail.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports